import { render, staticRenderFns } from "./DefaultValueConfig.vue?vue&type=template&id=68d755bc&scoped=true&"
import script from "./DefaultValueConfig.vue?vue&type=script&lang=js&"
export * from "./DefaultValueConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d755bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d755bc')) {
      api.createRecord('68d755bc', component.options)
    } else {
      api.reload('68d755bc', component.options)
    }
    module.hot.accept("./DefaultValueConfig.vue?vue&type=template&id=68d755bc&scoped=true&", function () {
      api.rerender('68d755bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/DefaultValueConfig.vue"
export default component.exports